import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import styled from "styled-components/macro";
import { smallShadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { fetchCategories, selectCategories } from "./categoriesSlice";
import CategoryRow from "./components/CategoryRow";

interface CategoriesProps {}

const Categories: React.FC<CategoriesProps> = ({}) => {
  const dispatch = useDispatch();

  const categories = useSelector(selectCategories);

  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  return (
    <CategoriesContainer>
      <TopContainer>
        <span className="text-body">Категории</span>
      </TopContainer>
      {categories.map((category) => (
        <CategoryRow key={category._id} category={category} />
      ))}
    </CategoriesContainer>
  );
};

const CategoriesContainer = styled.div`
  margin-top: 30px;
  ${smallShadow}
`;

const TopContainer = styled.div`
  padding: 10px;
  background-color: ${colors.darkest};
  font-weight: bold;

  span {
    color: white;
  }
`;

export default Categories;
